import React, { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";
import "./imageGallery.css";

const ImageVideoGallery = () => {
  const { imagesUrl, videosUrl } = useDashBoardData();
  const [data, setData] = useState({ media: "", type: "" });

  // console.log("videosUrl", videosUrl);

  const viewMedia = (media, type) => {
    setData({ media, type });
  };

  const mediaAction = () => {
    setData({ media: "", type: "" });
  };

  return (
    <>
      {data.media && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            background: "black",
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <button
            onClick={mediaAction}
            style={{ position: "absolute", top: "10px", right: "10px" }}
          >
            X
          </button>
          {data.type === "image" && (
            <img
              src={data.media}
              alt=""
              style={{ height: "auto", maxWidth: "90%", maxHeight: "90%" }}
            />
          )}
          {data.type === "video" && (
            <video
              controls
              autoPlay
              style={{ height: "auto", maxWidth: "90%", maxHeight: "90%" }}
            >
              <source src={data.media} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      )}
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
        data-aos-duration="1500"
        style={{ padding: "10px" }}
      >
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}>
          <Masonry gutter="10px">
            {imagesUrl.map((imageUrl, i) => (
              <img
                key={`image-${i}`}
                src={imageUrl}
                style={{
                  width: "100%",
                  display: "block",
                  // cursor: "pointer",
                  height: "250px",
                }}
                alt=""
                onClick={() => viewMedia(imageUrl, "image")}
              />
            ))}
            {videosUrl.map((videoUrl, i) => (
              <iframe
                key={`video-${i}`}
                title={`video-${i}`}
                className="video_gallery_iframe"
                src={videoUrl}
                frameBorder="0"
                allowFullScreen
                onClick={() => viewMedia(videoUrl, "video")}
                style={{height:"250px"}}
              ></iframe>
              // <video
              //   key={i}
              //   controls
              //   style={{
              //     width: "100%",
              //     display: "block",
              //     cursor: "pointer",
              //     height: "auto",
              //   }}
              //   onClick={() => viewMedia(videoUrl, "video")}
              // >
              //   <source src={videoUrl} type="video/mp4" />
              //   Your browser does not support the video tag.
              // </video>
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </>
  );
};

export default ImageVideoGallery;
